import React from 'react';
import propTypes from 'prop-types';
import { Avatar } from '@fiverr-private/fit';

const UserAvatar = ({ fullName, username, profileImage, isOnline, size = 32 }) => (
    <Avatar
        fullName={fullName}
        username={username}
        showOnlineIndicator
        isOnline={isOnline}
        src={profileImage}
        size={size}
    />
);

UserAvatar.propTypes = {
    fullName: propTypes.string,
    username: propTypes.string,
    profileImage: propTypes.string,
    isOnline: propTypes.bool,
    size: propTypes.number,
};

export default UserAvatar;
